import { Dialog } from '@headlessui/react'
import type { Dispatch, SetStateAction } from 'react'
import { useState } from 'react'

import FilterSaveIcon from '../../../../assets/images/icons/filter-save-icon.svg?react'
import XIcon from '../../../../assets/images/icons/x-close-filter.svg?react'
import FormElement from '../../../../utils/forms/form-element'
import TextInput from '../../../../utils/inputs/text-input'

type AppPropsDialog = {
  isOpen: boolean
  isLoading: boolean
  setIsOpen: Dispatch<SetStateAction<boolean>>
  onConfirm: (name: string) => () => Promise<void>
}

export default function FilterSaveModal({
  isOpen,
  setIsOpen,
  isLoading,
  onConfirm,
}: AppPropsDialog) {
  const [filterName, setFilterName] = useState('')

  return (
    <Dialog
      open={isOpen}
      onClose={() => setIsOpen(false)}
      className="relative z-50"
    >
      <div
        className="fixed inset-0 flex items-center justify-center p-4"
        style={{
          background: 'rgba(41, 41, 41, 0.7)',
          backdropFilter: 'blur(8px)',
        }}
      >
        <Dialog.Panel className="relative border rounded-xl shadow-xl bg-white-100">
          <div className="flex flex-col p-6 w-96">
            <div className="flex flex-col items-center">
              <div className="flex flex-row justify-center w-full">
                <FilterSaveIcon />
                <button
                  type="button"
                  className="absolute right-8 border-0 rounded-full p-2 active:bg-gray-100"
                  onClick={() => setIsOpen(false)}
                >
                  <XIcon />
                </button>
              </div>

              <h1 className="font-medium text-lg text-gray-900 pt-5 pb-2">
                Name filter to save
              </h1>
              <p className="font-normal text-sm text-gray-500 text-center pb-5">
                Please name the new quick filter to save it. You will be able to
                see this filter next to filter menu once saved.
              </p>
              <div className="w-full">
                <FormElement label="Filter name">
                  <TextInput
                    placeholder="e.g. Filter Name 01"
                    onChange={(e) => setFilterName(e.target.value)}
                  />
                </FormElement>
                <div className="flex flex-row items-end mt-8 space-x-3">
                  <button
                    type="button"
                    onClick={() => setIsOpen(false)}
                    className="h-11 w-full flex justify-center items-center border border-solid border-gray-300 rounded-lg active:bg-gray-100"
                  >
                    <span className="font-medium text-base text-gray-700">
                      Cancel and Discard
                    </span>
                  </button>
                  <button
                    type="button"
                    className="h-11 w-full flex justify-center items-center bg-primary-600 border border-solid border-primary-600 rounded-lg active:bg-primary-700"
                    disabled={!filterName || isLoading}
                    onClick={onConfirm(filterName)}
                  >
                    <span className="font-medium text-base text-white-100">
                      Save
                    </span>
                  </button>
                </div>
              </div>
            </div>
            <div className="flex flex-row"></div>
          </div>
        </Dialog.Panel>
      </div>
    </Dialog>
  )
}
